<template>
  <div id="home">  
    <Hero />
    <About />
    <Videos />
    <Buy />
    <!-- <Contact /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from '@/components/Hero.vue'
import About from '@/components/About.vue'
import Videos from '@/components/Videos.vue'
import Buy from '@/components/Buy.vue'
// import Contact from '@/components/Contact.vue'

export default {
  name: 'Home',
  components: {
    Hero,
    About,
    Videos,
    Buy,
    // Contact,
  }
}
</script>
